import { infiniteQueryOptions, queryOptions, skipToken } from '@tanstack/react-query';

import { SupportApi } from '@api/SupportApi';

import { SupportTicketListFilter, toTicketListQuery } from '../utils/ticketListFilter';

export const supportKeys = {
    all: ['support'] as const,
    ticketLists: () => [...supportKeys.all, 'ticketLists'] as const,
    ticketList: (filter: SupportTicketListFilter) => [...supportKeys.ticketLists(), filter] as const,
    ticket: (ticketId: string) => [...supportKeys.all, 'ticket', ticketId] as const,
    messages: (ticketId: string) => [...supportKeys.ticket(ticketId), 'messages'] as const,
    ticketStatuses: () => [...supportKeys.all, 'ticketStatuses'] as const,
    totalUnread: () => [...supportKeys.all, 'totalUnread'] as const,
};

export const supportQueryOptions = {
    ticketList: (filter: SupportTicketListFilter) =>
        infiniteQueryOptions({
            queryKey: supportKeys.ticketList(filter),
            queryFn: async ({ pageParam, signal, client }) => {
                const page = await SupportApi.listTickets(toTicketListQuery(filter, pageParam), signal);
                client.setQueryData(supportKeys.totalUnread(), page.totalUnread);
                return page;
            },
            initialPageParam: undefined as string | undefined,
            getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
        }),
    ticket: (ticketId: string) =>
        queryOptions({
            queryKey: supportKeys.ticket(ticketId),
            queryFn: () => SupportApi.getTicket(ticketId),
        }),
    messages: (ticketId: string) =>
        infiniteQueryOptions({
            queryKey: supportKeys.messages(ticketId),
            queryFn: ({ pageParam }) => SupportApi.listMessages(ticketId, pageParam),
            initialPageParam: undefined as string | undefined,
            getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
        }),
    ticketStatuses: () =>
        queryOptions({
            queryKey: supportKeys.ticketStatuses(),
            queryFn: () => SupportApi.listTicketStatuses(),
            gcTime: 0,
            retry: false,
        }),
    totalUnread: () =>
        queryOptions<number>({
            queryKey: supportKeys.totalUnread(),
            queryFn: skipToken,
        }),
};
